/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ListOperators } from '../models/ListOperators';
import { TagKeyValue } from '../models/TagKeyValue';

export class TagKeyValuesCondition {
  'operator': ListOperators;
  'tagKeyValues': Array<TagKeyValue>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "operator",
      "baseName": "operator",
      "type": "ListOperators",
      "format": ""
    },
    {
      "name": "tagKeyValues",
      "baseName": "tagKeyValues",
      "type": "Array<TagKeyValue>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return TagKeyValuesCondition.attributeTypeMap;
  }

  public constructor() {
  }
}



